import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class NavigatorService {
  private readonly renderer: Renderer2;

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  visibilityChange(cb: any) {
    this.renderer.listen('document', 'visibilitychange', (event: Event) => {
      if (typeof cb === 'function') {
        cb();
      }
    });
  }
}
